import comp from "./Worksheet";
export default comp;
